import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useEffect } from 'react';

import { Section } from '@/components/modules/Application/components/_shared/components/Section/Section';
import { SectionTitle } from '@/components/modules/Application/components/_shared/components/Section/SectionTitle';
import { PaymentMethodCardFactory } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodCardFactory';
import { usePaymentMethods } from '@/components/modules/Application/components/PaymentMethod/_shared/hooks/usePaymentMethods';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface PaymentMethodListProps {
  firstRendered: boolean;
}

export const PaymentMethodList = ({ firstRendered }: PaymentMethodListProps) => {
  const { customBorderRadius } = useCustomTheme();
  const { paymentMethodEntities, setupPaymentMethodEntity, areAllPaymentMethodEntitiesSetup } = usePaymentMethods();

  useEffect(() => {
    if (!paymentMethodEntities) return;

    paymentMethodEntities.forEach((paymentMethodEntity) => {
      if (!paymentMethodEntity.isSetup) {
        setupPaymentMethodEntity(paymentMethodEntity);
      }
    });
  }, [paymentMethodEntities]);

  return (
    <Section disableAnimation={firstRendered}>
      <SectionTitle title={'PAYMENT_METHOD'} subtitle={'PAYMENT_METHOD_INSTRUCTIONS'} />
      <Box display="flex" flexDirection="column" gridGap={16}>
        {paymentMethodEntities?.map((paymentMethodEntity, idx) =>
          areAllPaymentMethodEntitiesSetup ? (
            <PaymentMethodCardFactory
              key={`${idx}-${paymentMethodEntity.paymentMethodType}-${paymentMethodEntity.amount}`}
              paymentMethodEntity={paymentMethodEntity}
            />
          ) : (
            <Skeleton
              key={`${idx}-${paymentMethodEntity.paymentMethodType}-${paymentMethodEntity.amount}-skeleton`}
              variant="rect"
              width={'100%'}
              height={'79px'}
              style={{ borderRadius: customBorderRadius.paper }}
            />
          ),
        )}
      </Box>
    </Section>
  );
};
